import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UIkit'

const { makeStyles } = require('@material-ui/core')

export const useRequestCardStyles = makeStyles(() => ({
  filterTabs: {
    display: 'flex',
    flexWrap: 'nowrap',
    padding: 5,
    overflowX: 'auto',
    width: '100%'
  },
  tableStatusBtn: {
    padding: '8px 12px',
    fontSize: '14px',
    fontWeight: 600,
    color: GRAY_COLORS[500],
    whiteSpace: 'nowrap'
  },
  tableStatusBtnActive: {
    color: `${PRIMARY_COLORS[700]} !important`,
    backgroundColor: `${PRIMARY_COLORS[50]} !important`
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: PRIMARY_COLORS[700],
    marginBottom: 8
  },
  card: {
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 16,
    marginTop: 12
  },
  department: { fontSize: 18, fontWeight: 600, color: GRAY_COLORS[900] },
  module: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS[600],
    marginBottom: 12
  },
  responsible: {
    fontSize: 16,
    fontWeight: 500,
    color: GRAY_COLORS[900]
  },
  time: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS[600]
  }
}))
